module.exports = __webpack_public_path__ + "img/contact_img.0776c85a.png";